import { DiningOption, DiningRestaurantChoice, PackageRestaurant } from '../types';

type PackageRestaurantRestriction = Pick<PackageRestaurant, 'restaurantId' | 'menuIds'> & {
  timeRestrictions?: PackageRestaurant['timeRestrictions'];
};

export const getPackageRestaurantRestrictions = (
  restaurant: PackageRestaurant
): PackageRestaurantRestriction[] => [restaurant, ...(restaurant.additionalRestaurants ?? [])];

export const getPackageRestaurantChoices = (
  restaurant: PackageRestaurant
): DiningRestaurantChoice[] =>
  getPackageRestaurantRestrictions(restaurant).map(
    ({ restaurantId, menuIds, timeRestrictions }) => ({
      id: Number(restaurantId),
      menuIds: (menuIds || []).map((id) => Number(id)),
      timeslotRestrictions: timeRestrictions ?? null,
    })
  );

export const hasRestaurantChoice = (option: DiningOption) =>
  (option.restaurantChoices?.length ?? 0) > 1;

export const getSelectedRestaurantChoice = (
  option: DiningOption,
  selectedRestaurantId?: number
): DiningRestaurantChoice | undefined =>
  hasRestaurantChoice(option)
    ? option.restaurantChoices?.find(({ id }) => id === selectedRestaurantId)
    : option;
